{
  "version": 1,
  "asset_id": "09d4cd34-bf93-481e-a567-4d2f8fe9bba9",
  "project_id": "1203040e-940d-4f2e-ab5b-8733ed2d3c31",
  "url": "/__l5e/assets-v1/09d4cd34-bf93-481e-a567-4d2f8fe9bba9/opt_assistido-1.jpg",
  "r2_key": "a/v1/1203040e-940d-4f2e-ab5b-8733ed2d3c31/09d4cd34-bf93-481e-a567-4d2f8fe9bba9/opt_assistido-1.jpg",
  "original_filename": "opt_assistido-1.jpg",
  "size": 106640,
  "content_type": "image/jpeg",
  "created_at": "2026-08-26T20:32:47Z"
}
